export type ProjectFlowPathParams = {
  name?: string
  id?: string
  subsidiaryId?: string
}

export const isLinkedProjectPath = (pathname: string) => pathname.split('/').includes('nai-flow-view')

export const buildProjectFlowPath = ({ name, id, subsidiaryId }: ProjectFlowPathParams, suffix = '', linked = false) => {
  const projectPath = `/project-management/${name || ''}/${id || ''}`
  const flowPath = linked ? `${projectPath}${subsidiaryId ? `/${subsidiaryId}` : ''}/nai-flow-view` : `${projectPath}/nai-flow`
  return suffix ? `${flowPath}/${suffix.replace(/^\/+/, '')}` : flowPath
}

export const naiFlowTabs = [
  {
    label: 'Observations',
    path: `/project-management/:name/:id/nai-flow/observations`,
    slug: 'observations',
    page: 'nai-flow',
  },
  {
    label: 'Site Walkthrough',
    path: `/project-management/:name/:id/nai-flow/site-walkthrough`,
    slug: 'site-walkthrough',
    page: 'nai-flow',
  },
  {
    label: 'Incidents',
    path: `/project-management/:name/:id/nai-flow/incidents`,
    slug: 'incidents',
    page: 'nai-flow',
  },
  {
    label: 'Inspections',
    path: `/project-management/:name/:id/nai-flow/inspections/schedule`,
    // Section prefix: keeps this tab active for whichever capsule is chosen beneath it.
    matchPath: `/project-management/:name/:id/nai-flow/inspections`,
    slug: 'inspections',
    page: 'nai-flow',
  },
  {
    label: 'Audits',
    path: `/project-management/:name/:id/nai-flow/audits/schedule`,
    // Section prefix: keeps this tab active for whichever capsule is chosen beneath it.
    matchPath: `/project-management/:name/:id/nai-flow/audits`,
    slug: 'audits',
    page: 'nai-flow',
  },
  {
    label: 'Trainings',
    path: `/project-management/:name/:id/nai-flow/trainings`,
    slug: 'training',
    page: 'nai-flow',
  },
  {
    label: 'Statistics Capture',
    path: `/project-management/:name/:id/nai-flow/statistics-capture/schedule`,
    // Section prefix: keeps this tab active for whichever capsule is chosen beneath it.
    matchPath: `/project-management/:name/:id/nai-flow/statistics-capture`,
    slug: 'statistics-capture',
    page: 'nai-flow',
  },
  {
    label: 'Whatsapp Group',
    path: `/project-management/:name/:id/nai-flow/whatsapp-group`,
    slug: 'whatsapp-group',
    page: 'nai-flow',
  },
] as any

export const naiFlowViewTabs = [
  {
    label: 'Observations',
    path: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/observations`,
    slug: 'observations',
    page: 'nai-flow-view',
  },
  {
    label: 'Site Walkthrough',
    path: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/site-walkthrough`,
    slug: 'site-walkthrough',
    page: 'nai-flow-view',
  },
  {
    label: 'Incidents',
    path: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/incidents`,
    slug: 'incidents',
    page: 'nai-flow-view',
  },
  {
    label: 'Inspections',
    path: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/inspections/list`,
    // Section prefix: keeps this tab active for whichever capsule is chosen beneath it.
    matchPath: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/inspections`,
    slug: 'inspections',
    page: 'nai-flow-view',
  },
  {
    label: 'Audits',
    path: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/audits/list`,
    // Section prefix: keeps this tab active for whichever capsule is chosen beneath it.
    matchPath: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/audits`,
    slug: 'audits',
    page: 'nai-flow-view',
  },
  {
    label: 'Trainings',
    path: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/trainings`,
    slug: 'training',
    page: 'nai-flow-view',
  },
  {
    label: 'Statistics Capture',
    path: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/statistics-capture/schedule`,
    matchPath: `/project-management/:name/:id/:subsidiaryId/nai-flow-view/statistics-capture`,
    slug: 'statistics-capture',
    page: 'nai-flow-view',
  },
  // No Whatsapp Group here on purpose: it isn't offered for linked projects. This list drives
  // both the tab strip and the project-card quick links, so omitting it hides it from both.
] as any

export const projectUserManagementTabs = [
  {
    label: 'Users',
    slug: 'user',
    path: `/project-management/:name/:id/user-management/users`,
    page: 'project-user-management',
  },
  {
    label: 'Roles',
    slug: 'role',
    path: `/project-management/:name/:id/user-management/roles`,
    page: 'project-user-management',
  },
]

export const inspectionTabs = [
  {
    label: 'Schedule',
    path: `/project-management/:name/:id/nai-flow/inspections/schedule`,
    slug: 'schedule',
    page: 'inspections',
  },
  {
    label: 'Inspections List',
    path: `/project-management/:name/:id/nai-flow/inspections/list`,
    slug: 'inspections',
    page: 'inspections',
  },
  {
    label: 'Non-Conformance',
    path: `/project-management/:name/:id/nai-flow/inspections/non-conformance`,
    slug: 'non-conformance',
    page: 'inspections',
  },
]

export const auditTabs = [
  {
    label: 'Schedule',
    path: `/project-management/:name/:id/nai-flow/audits/schedule`,
    slug: 'audits',
    page: 'audits',
  },
  {
    label: 'Audits List',
    path: `/project-management/:name/:id/nai-flow/audits/list`,
    slug: 'audits',
    page: 'audits',
  },
  {
    label: 'Non-Conformance',
    path: `/project-management/:name/:id/nai-flow/audits/non-conformance`,
    slug: 'non-conformance',
    page: 'audits',
  },
]

export const statisticCaptureTabs = [
  {
    label: 'Schedule',
    path: `/project-management/:name/:id/nai-flow/statistics-capture/schedule`,
    slug: 'statistics-capture-schedule',
    page: 'statistics-capture',
  },
  {
    label: 'Report',
    path: `/project-management/:name/:id/nai-flow/statistics-capture/reports`,
    slug: 'statistics-capture-report',
    page: 'statistics-capture',
  },
]

const asLinkedProjectTab = (tab: any) => ({
  ...tab,
  path: tab.path.replace('/:id/nai-flow/', '/:id/:subsidiaryId/nai-flow-view/'),
  ...(tab.matchPath ? { matchPath: tab.matchPath.replace('/:id/nai-flow/', '/:id/:subsidiaryId/nai-flow-view/') } : {}),
})

export const linkedInspectionTabs = inspectionTabs.map(asLinkedProjectTab)
export const linkedAuditTabs = auditTabs.map(asLinkedProjectTab)
export const linkedStatisticCaptureTabs = statisticCaptureTabs.map(asLinkedProjectTab)

export const naiFlowDashboardsTabs = [
  // {
  //   label: 'Overview',
  //   path: `/dashboard/nai-flow/overview`,
  //   slug: 'org-dashboard',
  //   page: 'nai-flow-dashboard',
  // },
  {
    label: 'Observation Old',
    path: `/dashboard/nai-flow/observation-old`,
    slug: 'observations-dashboard-old',
    page: 'nai-flow-dashboard-old',
  },
  {
    label: 'Observation',
    path: `/dashboard/nai-flow/observation`,
    slug: 'observations-dashboard',
    page: 'nai-flow-dashboard',
  },
  {
    label: 'Incident',
    path: `/dashboard/nai-flow/incident`,
    slug: 'incidents-dashboard',
    page: 'nai-flow-dashboard',
  },
  {
    label: 'Inspection',
    path: `/dashboard/nai-flow/inspection`,
    slug: 'inspections-dashboard',
    page: 'nai-flow-dashboard',
  },
  {
    label: 'Audit',
    path: `/dashboard/nai-flow/audit`,
    slug: 'audits-dashboard',
    page: 'nai-flow-dashboard',
  },
  {
    label: 'Training',
    path: `/dashboard/nai-flow/training`,
    slug: 'training-dashboard',
    page: 'nai-flow-dashboard',
  },
  {
    label: 'Statistics Capture',
    path: `/dashboard/nai-flow/statistics-capture`,
    slug: 'statistics-capture-dashboard',
    page: 'nai-flow-dashboard',
  },
]

export const allTabs = [...naiFlowTabs, ...naiFlowViewTabs, ...projectUserManagementTabs, ...inspectionTabs, ...auditTabs, ...statisticCaptureTabs, ...naiFlowDashboardsTabs]
